/**
 * Purple Bear Projects - Theme JS
 */

(function() {
  'use strict';

  /* ── Mobile Navigation Toggle ── */
  window.toggleMob = function() {
    const hbg = document.getElementById('hbg');
    const mob = document.getElementById('mob');
    if (!hbg || !mob) return;

    hbg.classList.toggle('open');
    mob.classList.toggle('open');

    // Prevent scrolling when mobile nav is open
    document.body.style.overflow = mob.classList.contains('open') ? 'hidden' : '';
  };

  /* ── Navigation Background on Scroll ── */
  const nav = document.getElementById('nav');
  const heroSection = document.querySelector('.home-hero');

  window.addEventListener('scroll', function() {
    if (!nav) return;

    if (heroSection) {
      // Home page behavior: Transparent over hero, light-bg after hero
      const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
      if (window.scrollY > heroBottom - 70) {
        nav.classList.add('light-bg');
      } else {
        nav.classList.remove('light-bg');
      }
    } else {
      // Other pages: Always light-bg
      nav.classList.add('light-bg');
    }
  });

  // Initial check on load
  if (nav) {
    if (!heroSection) {
      nav.classList.add('light-bg');
    } else {
      const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
      if (window.scrollY > heroBottom - 70) {
        nav.classList.add('light-bg');
      }
    }
  }

  /* ── Intersection Observer for Scroll Animations ── */
  const scrollObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        // Support for older 'vis' class if used in CSS
        entry.target.classList.add('vis');
        scrollObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  // Select all elements that should animate on scroll
  const animElements = document.querySelectorAll(
    '.pj-card, .stat-card, .v-card, .mv-card, .ct-off, .ct-form, .ct-info, .sv-card, .proc-step, .nw-item, .pt-card'
  );

  animElements.forEach((el, i) => {
    // Apply staggered delay if not already set
    if (!el.style.transitionDelay) {
      // Stagger by 3s for grids (assuming 3 or 4 columns)
      el.style.transitionDelay = (i % 3) * 100 + 'ms';
    }
    scrollObserver.observe(el);
  });

  /* ── Home Page Slideshow ── */
  const slides = document.querySelectorAll('.ss-slide');
  if (slides.length > 0) {
    let si = 0;
    let sst = null;

    const nextSlide = () => {
      if (slides.length <= 1) return;
      slides[si].classList.remove('on');
      si = (si + 1) % slides.length;
      slides[si].classList.add('on');
    };

    const startSS = () => {
      if (sst || slides.length <= 1) return;
      sst = setInterval(nextSlide, 5000);
    };

    const stopSS = () => {
      if (sst) {
        clearInterval(sst);
        sst = null;
      }
    };

    // Initialize first slide state
    slides.forEach((s, i) => i === 0 ? s.classList.add('on') : s.classList.remove('on'));
    startSS();
  }

  /* ── Project Filter ── */
  window.filterProjects = function(type) {
    const cards = document.querySelectorAll('.pj-card');
    const btns = document.querySelectorAll('.flt');
    const e = window.event;

    // Update buttons
    btns.forEach(btn => btn.classList.remove('on'));
    if (e && e.currentTarget && e.currentTarget.classList.contains('flt')) {
      e.currentTarget.classList.add('on');
    }

    // Filter cards
    cards.forEach((card, i) => {
      if (type === 'all') {
        card.classList.remove('hide');
      } else {
        const types = card.getAttribute('data-type') || '';
        if (types.split(' ').includes(type)) {
          card.classList.remove('hide');
        } else {
          card.classList.add('hide');
        }
      }
    });

    // Re-observe visible cards for scroll animation and reset delays
    const visibleCards = document.querySelectorAll('.pj-card:not(.hide)');
    visibleCards.forEach((el, i) => {
      el.style.transitionDelay = (i % 3) * 100 + 'ms';
      if (!el.classList.contains('visible')) {
        scrollObserver.observe(el);
      }
    });
  };

  /* ── Contact Form Handling ── */
  const contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      // If it's a Shopify form, we might want to let it submit naturally
      // or handle success message via AJAX.

      // Check if it's a Shopify form (action starts with /contact)
      const action = contactForm.getAttribute('action');
      const isShopifyForm = action && action.includes('/contact');

      if (!isShopifyForm) {
        e.preventDefault();
        const btn = this.querySelector('.ct-submit');
        if (!btn) return;
        const originalText = btn.textContent;

        btn.textContent = 'Message Sent!';
        btn.style.background = 'linear-gradient(135deg, #10b981, #059669)';
        btn.style.boxShadow = '0 3px 20px rgba(16,185,129,.3)';

        setTimeout(() => {
          this.reset();
          btn.textContent = originalText;
          btn.style.background = '';
          btn.style.boxShadow = '';
        }, 3000);
      }
    });
  }

})();
